// Mock data for PSS Group rebrand. Replace with backend later.

export const IMAGES = {
  hero: "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&w=1920",
  heroAlt: "https://images.unsplash.com/photo-1548774432-58253e163355?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjB3b3JrZXJzJTIwc2FmZXR5JTIwdmVzdHN8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzgyNDEyMzM3fDA&ixlib=rb-4.1.0&q=85",
  aboutMain: "https://customer-assets.emergentagent.com/job_flex-jobs-4/artifacts/dszd0t5o_image.png",
  aboutAlt: "https://images.pexels.com/photos/30341205/pexels-photo-30341205.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  companies: "https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  companiesAlt: "https://images.pexels.com/photos/8112186/pexels-photo-8112186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workers: "https://images.unsplash.com/photo-1577894947058-cfdae4276bef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxmYWN0b3J5JTIwd29ya2Vyc3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODI0MTIzMzd8MA&ixlib=rb-4.1.0&q=85",
  workersAlt: "https://images.unsplash.com/photo-1576666735065-b24beb27b939?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxmYWN0b3J5JTIwd29ya2Vyc3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODI0MTIzMzd8MA&ixlib=rb-4.1.0&q=85",
};

// Stats shown in counters (only verifiable claims)
export const STATS = [
  { value: "93%", key: "retentionLabel" },
  { value: "8", key: "countries" },
];

// Job categories localized
export const CATEGORIES = {
  pl: ["Logistyka", "Produkcja", "Magazyn", "Pakowanie", "Budowa"],
  en: ["Logistics", "Production", "Warehouse", "Packaging", "Construction"],
  uk: ["Логістика", "Виробництво", "Склад", "Пакування", "Будівництво"],
};

// Each job carries localized title/location/type by language code
export const JOBS = [
  {
    id: "wh-operator",
    categoryIndex: 2,
    salary: "4 800 – 6 200 PLN",
    title: { pl: "Operator magazynowy", en: "Warehouse Operator", uk: "Оператор складу" },
    location: { pl: "Wrocław", en: "Wroclaw", uk: "Вроцлав" },
    type: { pl: "Pełny etat", en: "Full-time", uk: "Повний день" },
  },
  {
    id: "forklift",
    categoryIndex: 0,
    salary: "5 200 – 6 800 PLN",
    title: { pl: "Operator wózka widłowego", en: "Forklift Operator", uk: "Водій навантажувача" },
    location: { pl: "Poznań", en: "Poznan", uk: "Познань" },
    type: { pl: "Pełny etat", en: "Full-time", uk: "Повний день" },
  },
  {
    id: "production",
    categoryIndex: 1,
    salary: "4 600 – 5 900 PLN",
    title: { pl: "Pracownik produkcji", en: "Production Worker", uk: "Працівник виробництва" },
    location: { pl: "Łódź", en: "Lodz", uk: "Лодзь" },
    type: { pl: "System zmianowy", en: "Shift work", uk: "Змінна робота" },
  },
  {
    id: "packer",
    categoryIndex: 3,
    salary: "4 400 – 5 500 PLN",
    title: { pl: "Pracownik pakowania", en: "Packaging Worker", uk: "Працівник пакування" },
    location: { pl: "Warszawa", en: "Warsaw", uk: "Варшава" },
    type: { pl: "Pełny etat", en: "Full-time", uk: "Повний день" },
  },
  {
    id: "qc",
    categoryIndex: 1,
    salary: "5 000 – 6 400 PLN",
    title: { pl: "Kontroler jakości", en: "Quality Controller", uk: "Контролер якості" },
    location: { pl: "Kraków", en: "Krakow", uk: "Краків" },
    type: { pl: "Pełny etat", en: "Full-time", uk: "Повний день" },
  },
  {
    id: "builder",
    categoryIndex: 4,
    salary: "5 500 – 7 200 PLN",
    title: { pl: "Pracownik budowlany", en: "Construction Worker", uk: "Будівельник" },
    location: { pl: "Gdańsk", en: "Gdansk", uk: "Гданськ" },
    type: { pl: "Kontrakt", en: "Contract", uk: "Контракт" },
  },
  {
    id: "picker",
    categoryIndex: 0,
    salary: "4 700 – 6 000 PLN",
    title: { pl: "Kompletacja zamówień", en: "Order Picker", uk: "Комплектувальник замовлень" },
    location: { pl: "Wrocław", en: "Wroclaw", uk: "Вроцлав" },
    type: { pl: "System zmianowy", en: "Shift work", uk: "Змінна робота" },
  },
  {
    id: "line-lead",
    categoryIndex: 1,
    salary: "6 000 – 7 800 PLN",
    title: { pl: "Lider linii produkcyjnej", en: "Production Line Leader", uk: "Лідер виробничої лінії" },
    location: { pl: "Poznań", en: "Poznan", uk: "Познань" },
    type: { pl: "Pełny etat", en: "Full-time", uk: "Повний день" },
  },
];

export const CONTACT_INFO = {
  email: "p.sluzalek@pss-group.pl",
  phone: "+48 789 478 483",
  address: {
    pl: "Aleja Marszałka Józefa Piłsudskiego 77, 10-449 Olsztyn, Polska",
    en: "Aleja Marszałka Józefa Piłsudskiego 77, 10-449 Olsztyn, Poland",
    uk: "Aleja Marszałka Józefa Piłsudskiego 77, 10-449 Ольштин, Польща",
    es: "Aleja Marszałka Józefa Piłsudskiego 77, 10-449 Olsztyn, Polonia",
  },
};
